<template>
  <div class="product-details-content-register-submodule-basic">
    <div class="my-6">
      <step-title
        title="Informações básicas"
        description="Configure o submódulo"
        icon="fa-solid fa-info"
        fa
      />
    </div>
    <div class="row">
      <div class="col-lg-12">
        <form-group
          v-model="form.name"
          id="name"
          class="mb-5"
          label="Nome do submódulo"
          placeholder="Ex: Introdução"
          :errors="errors.name"
          :maxLength="240"
          required
        />
        <div class="d-flex justify-content-end">
          <small
            class="text-secondary text-right mb-5 w-100"
            :class="{
              'text-danger': form.name && form.name.length >= 240
            }"
          >
            {{ `${form.name ? form.name.length : 0}/240` }}
          </small>
        </div>
        <action-dispatcher
          action="membersModules/get"
          :parameters="{
            product_id: $route.params.id,
            limit: 1000
          }"
        >
          <form-group
            v-model="form.parent"
            :errors="errors.parent"
            id="parent"
            placeholder="Selecione"
            label="Módulo"
            select
            :options="modulesOptions"
          />
          <small class="small-text text-secondary">
            Se este for um submódulo, escolha o módulo ao qual ele pertence
          </small>
        </action-dispatcher>

        <hr class="my-6" />

        <h6 class="subtitle m-0">
          Liberação do submódulo
        </h6>
        <small class="description">
          Determine em quantos dias o seu conteúdo será liberado após a compra.
        </small>

        <b-form-checkbox
          id="_days_to_release"
          v-model="days_to_release"
          switch
          class="mt-6 button"
        >
          Liberar após quantidade de dias
        </b-form-checkbox>

        <div v-if="days_to_release">
          <form-group
            v-model="form.days_to_release"
            :errors="errors.days_to_release"
            id="days_to_release"
            placeholder="0 dias"
            label="Liberar após"
            mask="###"
          />
        </div>

        <b-form-checkbox
          id="_release_at"
          v-model="release_at"
          switch
          class="mt-5 button"
        >
          Liberar em uma data específica
        </b-form-checkbox>

        <div v-if="release_at">
          <form-group
            v-model="form.release_at"
            :errors="errors.release_at"
            id="release_at"
            placeholder="00/00/0000"
            label="Liberar no dia"
            is-date
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    module: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const f = field => (get(this.module, field) || "").substr(0, 19);
    return {
      days_to_release: !!get(this.module, "days_to_release", 0),
      release_at: this.module.release_at && f("release_at") !== f("created_at")
    };
  },
  computed: {
    ...mapState("membersModules", ["modules"]),
    modulesOptions() {
      return [{ id: null, name: "Nenhum" }, ...this.modules];
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.product-details-content-register-submodule-basic {
  .subtitle {
    color: #3b3b4ae6;
    font-size: 16px;
    font-weight: 400;
  }
  .description {
    color: #77788ede;
    font-size: 13px;
  }
  .button {
    color: #3b3b4ae6;
    font-size: 15px;
    font-weight: 400;
  }
}
</style>
